import React from 'react'
import wbLogo from '../../img/world-bank-group.png'
import SocialBtns from './SocialBtns'

const Footer = props => {
  return (
    <>
      <SocialBtns goal={props.goal} headline={props.headline} />
      <footer>
        <ul className='programs'>
          <li>
            {' '}
            <a href='https://www.worldbank.org/'>
              <img src={wbLogo} className='wbLogo' alt='World Bank logo' />
            </a>
          </li>
          <li>
            <a href='http://www.worldbank.org/en/about/what-we-do/brief/ibrd'>
              IBRD
            </a>
          </li>
          <li>
            <a href='http://ida.worldbank.org/'>IDA</a>
          </li>
          <li>
            <a href='http://www.ifc.org'>IFC</a>
          </li>
          <li>
            <a href='http://www.miga.org'>MIGA</a>
          </li>
          <li>
            <a href='http://icsid.worldbank.org'>ICSID</a>
          </li>
        </ul>
        <ul className='misc'>
          <li>
            <a href='https://www.worldbank.org/en/about/legal'>Legal</a>
          </li>
          <li>
            <a href='https://www.worldbank.org/en/about/legal/privacy-notice'>
              Privacy Notice
            </a>
          </li>
          <li>
            <a href='https://www.worldbank.org/en/access-to-information'>
              Access to Information
            </a>
          </li>
          <li>
            <a href='https://www.worldbank.org/en/about/careers'>Jobs</a>
          </li>
          <li>
            <a href='https://www.worldbank.org/en/about/contacts'>Contact</a>
          </li>
          <li>
            <a href='https://wbgcmsprod.microsoftcrmportals.com/en-US/anonymous-users/int-fraud-management/create-new-complaint/?clear'>
              REPORT FRAUD OR CORRUPTION
            </a>
          </li>
        </ul>
        <div>© 2020 The World Bank Group, All Rights Reserved. </div>
      </footer>
    </>
  )
}

export default Footer
